import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import ReactEcharts from "echarts-for-react";
import multiTooltip from './multi-tooltip';

const formatHour = (value) => {
    return moment(value, "HH").format("h A")
}

function HourlyGraph(props) {
    const { data } = props;
    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' });

    const option = useMemo(() => {
        if (!data || !data.length) return;
        const ownBusiness = data.find(data => data.own_business)
        const otherBusinesses = data.find(data => !data.own_business)

        const option = {
            grid: { top: 32, right: 20, bottom: 20, left: 52 },
            legend: { icon: 'roundRect' },
            xAxis: {
                type: 'value',
                min: 0,
                max: 23,
                axisLabel: { formatter: formatHour },
            },
            yAxis: { type: 'value' },
            tooltip: {
                trigger: 'axis',
                formatter: (params) => multiTooltip({
                    params,
                    formatAxisValueFn: formatHour,
                    formatFn: (value) => value.toFixed(2)
                })
            },
            series: [
                {
                    name: t("myBusiness"),
                    type: 'line',
                    data: ownBusiness.data || [],
                    itemStyle: { color: "#00a4e0" },
                    lineStyle: { color: "#00a4e0" }

                },
                {
                    name: t("otherBusinesses"),
                    type: 'line',
                    data: otherBusinesses.data || [],
                    itemStyle: { color: "#69B75C" },
                    lineStyle: { color: "#69B75C" }
                },
            ],
            dataZoom: [
                {
                    type: 'inside',
                    orient: 'horizontal',
                    start: 0,
                    end: 100,
                    minSpan: 10,
                },
                {
                    type: 'slider',
                    show: false,
                }
            ],
        };
        return option;
    }, [data, i18n.language])

    return (
        <div className="dashboardView-card rasd-hour dashboard-graph-card">
            <p className="dashboardView-card-title">{t("hourlyVisits")}</p>
            {
                option
                    ? <ReactEcharts option={option} />
                    : <p>N/D</p>
            }
        </div>
    )
}

export default HourlyGraph